module.exports = __webpack_public_path__ + "img/mint-right.27aef726.png";